// DOM version of iconText: HTML-escape the text, then tokens → <img> (sized 1.2em by CSS).
import { ICONS } from './icons.mjs';
import { assetUrl } from '../assetVersion.js';

const esc = (s) => s.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
export function iconHtml(text) {
  return esc(String(text ?? '')).replace(/\{([a-z_]+)\}/g, (m, name) => (name in ICONS
    ? `<img class="icon" src="${assetUrl(`/assets/icons/${name}.png`)}" alt="" draggable="false">` : m));
}
